module.exports = __webpack_public_path__ + "static/img/ok.e8e4692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/release/ok.png
// module id = tn/E
// module chunks = 1